/** @jsx jsx */
import PropTypes from "prop-types"
import { LocalizedLink } from "gatsby-theme-i18n"
import { jsx, Flex, Styled } from "theme-ui"
import useLocales from "hooks/use-locales"

import Container from "../grid/container"
import Menu from "components/menu"
import LogoEn from "components/svgs/logo-en"
import LogoFr from "components/svgs/logo-fr"

const Header = () => {
  const { Switcher, t, locale } = useLocales()
  return (
    <header
      sx={{
        bg: "secondary",
        py: 2,
        position: "sticky",
        top: 0,
        width: "100%",
        zIndex: 1080,
      }}
    >
      <Container wide>
        <Flex
          sx={{
            alignItems: "center",
            flexWrap: "nowrap",
            justifyContent: "space-between",
          }}
        >
          <Flex sx={{ alignItems: "center", flexWrap: "nowrap" }}>
            <LocalizedLink to="/">
              {locale == "fr" ? (
                <LogoFr sx={{ verticalAlign: "top", mr: 3 }} />
              ) : (
                <LogoEn sx={{ verticalAlign: "top", mr: 3 }} />
              )}
            </LocalizedLink>
            <Styled.p
              sx={{
                my: 0,
                color: "background",
                fontSize: [0, 1, 4],
                display: ["none", "inline-block"],
              }}
            >
              {t("description")}
            </Styled.p>
          </Flex>
          <Flex>
            <Switcher sx={{ mr: 3 }} />
            <Menu />
          </Flex>
        </Flex>
      </Container>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

export default Header
